import { createV3Queries } from "@query/utils/createV3Queries";
import { personsApi } from "@api";

export const queriesPersons = createV3Queries("personsApi", personsApi);
